import {
  BADGE_VALUES,
  ElementUIState,
} from '../../Controllers/UIController/UITypes';
import { waitFor } from '../../utils';
import { TutorialModule } from './TutorialModule';
import { t } from 'i18next';

export class FriendsButton extends TutorialModule {
  id = 'FriendsButton' as 'FriendsButton';

  onAction = (id?: string) => {
    this.app.ui.tooltip.hide();
    if (id === 'friends') {
      this.onComplete();
    }
  };

  execute = async () => {
    this.app.ui.setTutorialUIState({
      badges: {
        mine: 0,
        earn: 0,
        friends: 0,
        boosters: 0,
        trading: BADGE_VALUES.TRADING_ALERT,
      },
    });

    this.app.ui.setClickerUIState({
      btnClicker: ElementUIState.Normal,
      btnLeague: ElementUIState.Inactive,

      footer: ElementUIState.Normal,

      btnFriends: ElementUIState.Highlight,
      btnMine: ElementUIState.Mystery,
      btnEarn: ElementUIState.Mystery,
      btnBooster: ElementUIState.Normal,
      btnTeam: ElementUIState.Hidden,
    });

    await waitFor(300);

    this.app.tutorial.showTooltip({
      text: t('tut_tooltip_friendsbetter'),
      origin: { x: '22%', y: '100%' },
      offset: { x: '0px', y: '-185px' },
      align: 'bottom',
    });

    return super.execute().then(() => {
      this.app.ui.tooltip.hide();
    });
  };

  getAnalyticsOpts() {
    return {
      key: 'FTUE_friends_press_friends_button',
      data: {
        has_friends: this.app.state.friendCount > 0,
      },
    };
  }
}
